<template>
    <div></div>
</template>
<script>
    import {
        mapActions,
    } from 'vuex';

    import {
        LOCAL_STORAGE_USER,
        LOCAL_STORAGE_TOKEN_EXPIRES,
        LOCAL_STORAGE_JWT,
    } from '../utils/constants';

    export default {
        name: 'impersonate',
        props: {
            token: {
                required: false,
                type: String,
            },
            expire: {
                required: false,
                type: String,
            },
            userId: {
                required: false,
                type: String,
            },
            target: {
                required: false,
                type: String,
            },
            targetId: {
                required: false,
                type: String,
            },
        },
        methods: {
            ...mapActions([
                'fetchBootstrap',
                'fetchInit',
            ]),
        },
        async mounted() {
            localStorage.setItem(LOCAL_STORAGE_USER, this.userId);
            localStorage.setItem(LOCAL_STORAGE_TOKEN_EXPIRES, this.expire);
            localStorage.setItem(LOCAL_STORAGE_JWT, this.token);

            await this.fetchInit({ impersonate: true });
            await this.fetchBootstrap();

            if (this.target) {
                this.$router.push({ name: this.target, params: { newsId: this.targetId } });
            }
        },
    };
</script>
